// =============================================================================
// Business Hours - Orari di apertura dell'organizzazione
// =============================================================================
// Vivono in `tenant.settings.businessHours`: `null`/assente su un giorno
// significa chiuso. Sono orari wall-clock nel fuso dell'organizzazione, quindi
// si passano come stringhe "HH:mm" senza conversioni.
// ⚠️ I default replicano quelli del backend
// (backend/src/common/constants/business-hours.constants.ts), che li usa per
// gli orari delle nuove risorse: tenere le due liste allineate.

import type { BusinessHours, DayHours } from '../api/hooks';

/** Chiavi di `BusinessHours` indicizzate per giorno della settimana (0 = domenica). */
export const BUSINESS_HOURS_DAY_KEYS: (keyof BusinessHours)[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const DEFAULT_BUSINESS_HOURS: BusinessHours = {
  monday: { start: '08:00', end: '20:00' },
  tuesday: { start: '08:00', end: '20:00' },
  wednesday: { start: '08:00', end: '20:00' },
  thursday: { start: '08:00', end: '20:00' },
  friday: { start: '08:00', end: '20:00' },
  saturday: { start: '09:00', end: '13:00' },
  sunday: null,
};

/**
 * Orari di apertura per un giorno della settimana (0 = domenica), `null` se
 * l'organizzazione è chiusa. Senza orari configurati valgono i default, gli
 * stessi che la pagina Organizzazione mostra come valori iniziali.
 */
export function businessHoursForDay(
  hours: BusinessHours | undefined,
  dayOfWeek: number,
): DayHours | null {
  const key = BUSINESS_HOURS_DAY_KEYS[dayOfWeek];
  if (!key) return null;
  return (hours ?? DEFAULT_BUSINESS_HOURS)[key] ?? null;
}
